import { createFileRoute } from '@tanstack/react-router';
import Characters from 'src/pages/Organization/Players/Characters';

export const Route = createFileRoute(
  '/$organizationSlug/players/$playerId/characters/',
)({
  component: Characters,
});
